"use client";

import {
  Drawer,
  DrawerContent,
  DrawerHeader,
  DrawerTitle,
} from "@/components/ui/drawer";

interface AppDrawerProps {
  onClose: () => void;
  title?: string;
  children: React.ReactNode;
  className?: string;
}

export default function AppDrawer({
  onClose,
  title,
  children,
  className = "p-4",
}: AppDrawerProps) {
  return (
    <Drawer open={true} onOpenChange={onClose}>
      <DrawerContent className={className}>
        {/* Screen reader accessible header */}
        {title && (
          <DrawerHeader className="sr-only p-0">
            <DrawerTitle>{title}</DrawerTitle>
          </DrawerHeader>
        )}
        {children}
      </DrawerContent>
    </Drawer>
  );
}
